import JournalDetails from "components/journals/JournalDetails"
import Invite from "components/users/Invite"
import PersonAdd from "@material-ui/icons/PersonAdd";
import AddIcon from "@material-ui/icons/Add";
import NavRoutes from "./NavRoutes";
const DashboardRoutes = [
    {
        path: '/journal/:id',
        short: 'Details',
        name: 'Journal Details',
        mini: 'JD',
        icon: PersonAdd,
        component: JournalDetails
    },
    {
        path: '/invite/:companyName/:projectName',
        short: 'Invite',
        name: 'Invite User',
        mini: 'I',
        icon: AddIcon,
        component: Invite
    }
].concat(NavRoutes);

export default DashboardRoutes;


// WEBPACK FOOTER //
// ./src/routes/DashboardRoutes.js